/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import Head from 'next/head';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import { MEDIA_MIN_WIDTH } from '../../../constants';

type PageContextType = {
  showLocalTime: boolean;
  day: string;
  setShowLocalTime: Dispatch<SetStateAction<boolean>>;
};
const PageContext = createContext<PageContextType>({
  day: '09/28/2023',
  showLocalTime: false,
  setShowLocalTime: () => {},
});

export function Page({ children, day }: { children: ReactNode; day: string }) {
  const [showLocalTime, setShowLocalTime] = useState(false);
  return (
    <PageContext.Provider value={{ showLocalTime, setShowLocalTime, day }}>
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Chivo+Mono:wght@300;400;600&display=swap"
          rel="stylesheet"
        />
      </Head>
      <div
        css={css({
          backgroundColor: Colors.white,
          position: 'relative',
          top: '60px',
          [MEDIA_MIN_WIDTH.medium]: {
            top: '80px',
          },
        })}
      >
        {children}
      </div>
    </PageContext.Provider>
  );
}

export function usePageContext() {
  return useContext(PageContext);
}
